import React, { FC, MouseEvent, ReactNode } from "react";
import {
  ButtonColor,
  ButtonSize,
  ButtonType,
  ButtonVariant,
} from "enums/Button";
import { PreLoaderColor } from "enums/PreLoader";
import { CustomButton, Spinner } from "./Button.style";

type UniversalClickHandler =
  | ((event: MouseEvent<HTMLButtonElement>) => void)
  | ((...args: any[]) => void);
export interface ButtonProps {
  children: ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  type?: ButtonType;
  size?: ButtonSize;
  variant?: ButtonVariant;
  color?: ButtonColor;
  title?: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  tabIndex?: number;
  hidden?: boolean;
  className?: string;
}

const Button: FC<ButtonProps> = ({
  children,
  isLoading = false,
  color = ButtonColor.Black50,
  variant = ButtonVariant.Basic,
  size = ButtonSize.Small,
  tabIndex = 0,
  disabled = false,
  type = ButtonType.Button,
  className = "",
  ...otherProps
}) => {
  const spinnerColor =
    color === ButtonColor.Black50 ? PreLoaderColor.Grey : PreLoaderColor.White;

  return (
    <CustomButton
      size={size}
      color={color}
      $variant={variant}
      tabIndex={tabIndex}
      disabled={disabled}
      type={type}
      className={className}
      {...otherProps}
    >
      {isLoading && <Spinner color={spinnerColor} isActive={isLoading} />}
      {/* Bare text children get their own element so the spinner is inserted
          before a node React owns. Browser page translation (Chrome, Yandex,
          Safari) replaces text nodes with its own wrappers, and inserting the
          spinner before such a stale text node throws NotFoundError. */}
      {React.Children.map(children, (child) =>
        typeof child === "string" || typeof child === "number" ? (
          <span>{child}</span>
        ) : (
          child
        ),
      )}
    </CustomButton>
  );
};

export default React.memo(Button);
